
import { Enums } from '../common/enums'

import { IOpData } from '../util/interfaces'

import { OpConsumerTransaction } from './op-consumer-transaction'
import { OpDataType } from './op-data-type'


export class OpConsumerTransactionData implements IOpData {

    // Properties

    public idConsumerTransactionData: number
    public idConsumerTransaction: number
    public idDataType: number
    public indexNbr: number
    public value: any

    // Properties end


    // NavigationProperties

    public consumerTransaction: OpConsumerTransaction
    public dataType: OpDataType

    // NavigationProperties end


    constructor(opObj: any) {
        this.fromJSON(opObj)
    }


    // IOpChangeState implementation

    public opState: Enums.OpChangeState

    // IOpChangeState implementation end


    // IOpData implementation

    public get idData() { return this.idConsumerTransactionData }
    public set idData(idData: number) { this.idConsumerTransactionData = idData }

    public get indexNBR() { return this.indexNbr }
    public set indexNBR(indexNBR: number) { this.indexNbr = indexNBR }

    // IOpData implementation end

    public toString() {
        return "ConsumerTransactionData [" + this.idData + "]"
    }

    public fromJSON(opObj: any, compress: boolean = false) {
        if (opObj) {
            this.idConsumerTransactionData = opObj.ID_CONSUMER_TRANSACTION_DATA
            this.idConsumerTransaction = opObj.ID_CONSUMER_TRANSACTION
            this.idDataType = opObj.ID_DATA_TYPE
            this.indexNbr = opObj.INDEX_NBR
            this.value = opObj.VALUE
            this.opState = opObj.OpState

            this.dataType = opObj._DataType != null ? new OpDataType(opObj._DataType) : null
            this.consumerTransaction = opObj._ConsumerTransaction != null ? new OpConsumerTransaction(opObj._ConsumerTransaction) : null
        } else {
            this.idConsumerTransactionData = 0;
            this.opState = Enums.OpChangeState.New
        }
    }

    public toJSON(compress: boolean = false): any {
        return {
            ID_CONSUMER_TRANSACTION_DATA: this.idConsumerTransactionData,
            ID_CONSUMER_TRANSACTION: this.idConsumerTransaction,
            ID_DATA_TYPE: this.idDataType,
            INDEX_NBR: this.indexNbr,
            VALUE: this.value
        }
    }

    public static fromIOpData(data: IOpData): OpConsumerTransactionData {
        const newData: OpConsumerTransactionData = new OpConsumerTransactionData(null)

        newData.idConsumerTransactionData = data.idData
        newData.idDataType = data.idDataType
        newData.indexNbr = data.indexNBR
        newData.value = data.value
        newData.opState = data.opState

        return newData
    }
}